<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    role="presentation"
    class="animate-spin"
    :class="{ 'h-4 w-4': size === 16, 'h-6 w-6': size === 24, 'h-8 w-8': size === 32 }"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ size?: 16 | 24 | 32 }>(), { size: 16 })
</script>
